import { Link } from "react-router-dom";
import { getCategories } from "@/lib/content";

const year = new Date().getFullYear();

export default function SiteFooter() {
  const categories = getCategories();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-8xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-marked-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黑料吃话</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-200/80">
              专注娱乐与网络热点的完整文字整理：时间线、对话实录、各方回应与观察笔记。
              我们相信，把事实按顺序摆好，比急着下结论更有价值。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/20 text-background-100/80 transition-colors hover:border-background-100/50 hover:text-background-50"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-semibold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li>
                <Link to="/" className="transition-colors hover:text-background-50">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/topics" className="transition-colors hover:text-background-50">
                  话题归档
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="transition-colors hover:text-background-50">
                  联系编辑部
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-semibold text-background-50">内容方向</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/topics?category=${cat.id}`}
                    className="transition-colors hover:text-background-50"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-semibold text-background-50">联系方式</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base" />
                <span>editor@heiliaochihua.cn</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base" />
                <span>工作日 10:00 - 19:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑料吃话 · 内容整理与观察平台。站内示例内容均为虚构或匿名化样本。</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-base" />
            坚持理性吃瓜，尊重事实与个人权益
          </p>
        </div>
      </div>
    </footer>
  );
}